import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import VueApollo from 'vue-apollo'
import { apolloClient } from './vue-apollo'
import VueRouter from 'vue-router'
import '@/plugins/apexcharts'
import store from './store/index'
import Form from '@/components/Form'
import SingleRunner from '@/components/SingleRunner'
import Placeholder from '@/components/Placeholder'
import vuetify from './plugins/vuetify'
import { datadogRum } from '@datadog/browser-rum'
import SingleSpeedMap from './components/SingleSpeedMap'
import ShortFormAPI from './components/ShortFormAPI'

Vue.config.productionTip = false
Vue.prototype.$silksUrl = process.env.VUE_APP_SILKS_URL

Vue.use(VueApollo)
Vue.use(VueRouter)
Vue.use(Vuex)

datadogRum.init({
  applicationId: 'b12d349e-8d23-4a0e-82cc-2a213414cadc',
  clientToken: 'pubb9077c58472f152af5f7fe3f57ff0a44',
  site: 'datadoghq.com',
  service: 'formguide',
  version: '1.0.0',
  sampleRate: 100,
  trackInteractions: true
})

const apolloProvider = new VueApollo({ defaultClient: apolloClient })
const s = new Vuex.Store(store)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '*/examples', component: Placeholder, props: true },
    { path: '*/:id/:raceNo/speedmap', component: SingleSpeedMap, props: true },
    { path: '*/:id/:raceNo/shortformapi', component: ShortFormAPI, props: true },
    { path: '*/:id/:raceNo/:runnerNo', component: SingleRunner, props: true },
    { path: '*/:id/:raceNo', component: Form, props: true }
  ]
})

router.beforeEach((to, from, next) => {
  const subdir = window.location.host.split('.')[0]
  const domain = 'bet-form'
  const pageToLoad = 'Form'

  if (subdir !== domain && to.name !== pageToLoad) {
    next({ component: pageToLoad, params: {} })
  } else {
    next()
  }
})

new Vue({
  apolloProvider,
  router: router,
  store: s,
  vuetify,
  render: h => h(App)
}).$mount('#app')
